export default __webpack_public_path__ + "static/media/Intercity_Health_Plan.24b15755.png";